import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointMd} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);


export const addressInputStyles = css`
  * {
    box-sizing: border-box;
  }

  #annotation {
    margin-bottom: var(--sbkCoreSpacingMd);
  }
  
  fieldset {
    border: 0;
    padding: 0;
    margin: 0;
    min-width: 0;
  }
  
  .row {
    display: flex;
      flex-direction: column;
   
      @media all and (min-width: ${breakpointMd}) {
          flex-direction: row;
          gap: 1rem;
      }

    .col-md-4 {
      width: 100%;
      @media all and (min-width: ${breakpointMd}) {
        width: calc(100% / 3);
      }
    }
    
    .col-md-8 {
      width: 100%;
      @media all and (min-width: ${breakpointMd}) {
        width: calc(100% * 2/3);
      }
    }
`;